import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import messages from 'containers/ApplicationPage/messages';
import { forEach } from 'lodash/collection';
import moment from 'moment';
import { getGender, filteredParty } from 'helpers/lang';

import {
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    backgroundColor: theme.palette.action.hover,
  },
}))(TableRow);

function createData(name, date, gender, isSmoker) {
  return { name, date, gender, isSmoker };
}

// const rows = [createData('Mr. Frank Smith', '02.05.1986', 'Male', 'Smoker')];

function InsuredPartyDetails(props) {
  const theme = useTheme();

  const { parties, classes } = props;
  const rows = [];

  forEach(filteredParty(parties, 'isLifeInsured'), party => {
    const rowData = createData(
      `${party.firstName} ${party.lastName}`,
      moment(party.dateOfBirth).format('DD MMMM YYYY'),
      getGender(party.gender),
      // party.isSmoke,
    );
    if (party?.partyapplicationrelationships?.isPrimaryLifeInsured) {
      rows.unshift(rowData);
    } else {
      rows.push(rowData);
    }
  });
  if (rows.length > 0) {
    return (
      <Grid item xs={12} md={10}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              variant="h3"
              style={{ color: theme.palette.primary.subMain }}
            >
              <FormattedMessage {...messages.theInsured} />
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TableContainer>
              <Table>
                <TableBody>
                  {rows.map((row, index) => (
                    <StyledTableRow key={`${row.name}-${index}`}>
                      <StyledTableCell component="th" scope="row" style={{ width: '30%' }}>
                        <Typography variant="h4" className={classes.bold}>
                          {rows.length > 0 && `${index + 1}: `}{row.name}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell style={{ width: '30%' , textAlign: 'center'}}>
                        <Typography variant="h4">{row.date}</Typography>
                      </StyledTableCell>
                      <StyledTableCell style={{ width: '40%' , textAlign: 'center'}}>
                        <Typography variant="h4">{row.gender}</Typography>
                      </StyledTableCell>
                      {/* <StyledTableCell>
                        <Typography variant="body1">{row.isSmoker}</Typography>
                      </StyledTableCell> */}
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Grid>
    );

  } else return ''
}

InsuredPartyDetails.propTypes = {
  parties: PropTypes.array,
};

export default InsuredPartyDetails;
